import { Plugin } from "@ckeditor/ckeditor5-core";
import { ReportBlockPromptButton } from "./plugins/ReportBlockPromptButton.plugin";
import { ReportBlockPromptConversion } from "./plugins/ReportBlockPromptConversion.plugin";

export class ReportBlockPromptWidgets extends Plugin {
  static get requires() {
    return [ReportBlockPromptConversion, ReportBlockPromptButton];
  }
}
